import React, { HTMLProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface DropdownProps extends HTMLProps<HTMLDivElement> {
  children: React.ReactNode
}

const Dropdown = ({ children, className }: DropdownProps) => {
    return (
        <div className={twMerge('absolute z-10 md:-translate-x-6 pt-2 shadow', className)}>
            <div className='dropdown bg-white flex flex-col p-6 gap-y-4 text-black z-40'>{children}</div>
        </div>
    )
}

export default Dropdown
